import React from "react";
import { motion } from "framer-motion";

const DOCTRINE_BG =
  "https://static.prod-images.emergentagent.com/jobs/6bec4570-6aa6-48df-994c-3a5fa6a9a14a/images/682b424304db51b56412ce44097b5af6adc97aabb2f7e9ca87cd5d2ca3d21287.png";

export const Manifesto = () => {
  return (
    <section className="relative bg-white py-24 md:py-32 overflow-hidden" data-testid="manifesto-section">
      <div className="absolute inset-y-0 right-0 w-1/2 hidden lg:block opacity-90">
        <img src={DOCTRINE_BG} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/40 to-transparent" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-[#0A2463]" />
            <span className="font-headings text-xs tracking-[0.3em] uppercase text-[#0A2463]">
              Manifiesto
            </span>
          </div>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.7 }}
            className="font-headings font-bold uppercase tracking-tight text-[#0A192F] text-3xl sm:text-4xl lg:text-5xl leading-[1.05]"
          >
            "La escasez argentina no es natural.<br />
            Es producida <span className="fy-underline">institucionalmente</span>.<br />
            Y las arquitecturas <span className="text-[#0A2463]">se pueden cambiar</span>."
          </motion.h2>
          <p className="mt-10 text-lg text-[#4B5563] leading-relaxed max-w-2xl">
            Argentina es un país rico que vive en escasez. No por azar, sino por reglas e instituciones
            diseñadas para favorecer intermediarios y rentistas sobre los que producen. El Capitalismo
            de Abundancia es la doctrina para invertir esa arquitectura: poner el patrimonio, el trabajo
            y la Nación en el centro.
          </p>
          <div className="mt-10 inline-flex items-center gap-4 border-l-4 border-[#F5B400] pl-5">
            <span className="font-headings text-sm uppercase tracking-[0.25em] text-[#0A192F]">
              Un nuevo tiempo comienza
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
